import { render, staticRenderFns } from "./GridColSettings.vue?vue&type=template&id=4af8004e&scoped=true&"
import script from "./GridColSettings.vue?vue&type=script&lang=js&"
export * from "./GridColSettings.vue?vue&type=script&lang=js&"
import style0 from "./GridColSettings.vue?vue&type=style&index=0&id=4af8004e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8004e",
  null
  
)

export default component.exports